export const handleSendMessage = () =>
{
    const phoneNumber = "message/ZTCYSJRNOQCFL1"; // Replace with your WhatsApp phone number
    const url = `https://wa.me/${ phoneNumber }`;
    return url
};